import React from 'react';
import { ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
interface TrustRowProps {
  tone?: 'light' | 'dark';
  zeroRisk?: boolean;
  showDelivery?: boolean;
  className?: string;
}
export function TrustRow({
  tone = 'light',
  zeroRisk = false,
  showDelivery = false,
  className = ''
}: TrustRowProps) {
  const textColor = tone === 'dark' ? 'text-white/90' : 'text-brand-ink';
  const iconColor = tone === 'dark' ? 'text-brand-gold' : 'text-brand-orange';
  return <ul className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold leading-tight sm:text-sm ${textColor} ${className}`} data-id="element-158" data-mp="1k0qp425f6srf">
      {showDelivery && <li className="flex items-center gap-1" data-id="element-159" data-mp="1tywpgfbkvqu6">
          <ZapIcon className={`h-4 w-4 shrink-0 ${iconColor}`} aria-hidden="true" data-id="element-160" data-mp="1ty3knjw6jbeo" />
          Accès Immédiat • Livraison Numérique par E-mail
        </li>}
      <li className="flex items-center gap-1" data-id="element-161" data-mp="35ela301d0drt">
        <StarIcon className="h-4 w-4 shrink-0 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-162" data-mp="35dsbimck0ukr" />
        ⭐⭐⭐⭐⭐ 4,9/5 — Avis Clients Vérifiés
      </li>
      <li className="flex items-center gap-1" data-id="element-163" data-mp="3kvag0evzz2qm">
        <ShieldCheckIcon className={`h-4 w-4 shrink-0 ${iconColor}`} aria-hidden="true" data-id="element-164" data-mp="3ktz3nqohkmnw" />
        🛡️ Garantie Satisfait ou Remboursé de 14 Jours{zeroRisk ? ' — Zéro Risque' : ''}
      </li>
    </ul>;
}